import React from 'react';
import { useTranslation } from 'react-i18next';
import CallsActions from '../../calls/ui/calls-actions.jsx';

function ProfileIdentityContactTab({
  profileId,
  profile,
  canEdit,
  form,
  errors,
  isSaving,
  onFieldChange,
  onSave,
  onCancel,
  onOpenEmailModal,
  canRevealEmail,
  revealedEmail,
  onOpenEmailRevealModal,
  revealedPhone,
  onOpenPhoneRevealModal,
}) {
  const { t } = useTranslation();

  const inputProps = (field) => ({
    className: `form-control ${errors?.[field] ? 'is-invalid' : ''}`,
    value: form?.[field] || '',
    onChange: (event) => onFieldChange(field, event.target.value),
    disabled: !canEdit || isSaving,
    placeholder: field === 'phone' ? (profile?.phoneMasked || '') : undefined,
  });

  const renderError = (field) => (
    errors?.[field] ? <div className="invalid-feedback">{errors[field]}</div> : null
  );

  return (
    <div className="row g-3">
      <div className="col-xl-8">
        <form className="card card-body h-100" onSubmit={onSave}>
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-3">
            <h5 className="mb-0">{t('profiles.identityContact')}</h5>
            {canEdit ? (
              <div className="d-flex flex-wrap gap-2">
                <button type="button" className="btn btn-default" onClick={onCancel} disabled={isSaving}>
                  {t('common.cancel')}
                </button>
                <button type="submit" className="btn btn-primary" disabled={isSaving}>
                  {isSaving ? t('profiles.savingProfile') : t('common.save')}
                </button>
              </div>
            ) : null}
          </div>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label" htmlFor="profile-edit-first-name">{t('profiles.firstName')}</label>
              <input id="profile-edit-first-name" type="text" {...inputProps('firstName')} />
              {renderError('firstName')}
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="profile-edit-last-name">{t('profiles.lastName')}</label>
              <input id="profile-edit-last-name" type="text" {...inputProps('lastName')} />
              {renderError('lastName')}
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="profile-edit-phone">{t('profiles.phone')}</label>
              <input id="profile-edit-phone" type="text" {...inputProps('phone')} />
              {renderError('phone')}
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="profile-edit-country">{t('profiles.country')}</label>
              <input id="profile-edit-country" type="text" maxLength={2} {...inputProps('country')} />
              {renderError('country')}
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="profile-edit-language">{t('profiles.language')}</label>
              <input id="profile-edit-language" type="text" maxLength={2} {...inputProps('language')} />
              {renderError('language')}
            </div>
          </div>
        </form>
      </div>
      <div className="col-xl-4">
        <div className="card card-body h-100 d-flex flex-column gap-4">
          <div>
            <h5 className="mb-3">{t('profiles.emailPanelTitle')}</h5>
            <div className="text-break mb-3">{revealedEmail || profile?.email || '-'}</div>
            <div className="d-flex flex-wrap gap-2">
              {canRevealEmail && !revealedEmail ? (
                <button type="button" className="btn btn-outline-secondary" onClick={onOpenEmailRevealModal}>
                  <i className="ti ti-eye me-1"></i>
                  {t('profiles.revealEmail')}
                </button>
              ) : null}
              {canEdit ? (
                <button type="button" className="btn btn-outline-primary" onClick={onOpenEmailModal}>
                  {t('profiles.changeEmail')}
                </button>
              ) : null}
            </div>
          </div>
          <div>
            <h5 className="mb-3">{t('profiles.phonePanelTitle')}</h5>
            <div className="text-break mb-3">{revealedPhone || profile?.phoneMasked || '-'}</div>
            <div className="mb-2"><CallsActions profileId={profileId} profileLabel={profile?.name || ''} /></div>
            <div className="d-flex flex-wrap gap-2">
              {canRevealEmail && !revealedPhone ? (
                <button type="button" className="btn btn-outline-secondary" onClick={onOpenPhoneRevealModal}>
                  <i className="ti ti-eye me-1"></i>
                  {t('profiles.revealPhone')}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileIdentityContactTab;
